function generateMaskedEmail(email) {
  const [username, domain] = email.split('@');
  const maskedUsername = `${username.slice(0, 3)}${'*'.repeat(
    username.length - 3
  )}`;
  return `${maskedUsername}@${domain}`;
}

export { generateMaskedEmail };
